var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step1" }, [
    _c("div", { staticClass: "step1__content" }, [
      _c("p", { staticClass: "step1__header" }, [
        _vm._v("What Kind of Appointment are We Seeing You For?"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step1__options" }, [
        _c(
          "button",
          {
            staticClass: "step1__option",
            class: { "is-selected": _vm.type === "FreeConsultation" },
            on: {
              click: function ($event) {
                return _vm.selectAppointmentType("FreeConsultation")
              },
            },
          },
          [
            _c("img", {
              staticClass: "step1__img",
              attrs: {
                src: "https://midwest-beltone-com-iframes-prod.azurewebsites.net/images/online-scheduling-new-patient.jpg",
                alt: "New Patient",
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "step1__option",
            class: { "is-selected": _vm.type === "FollowUp" },
            on: {
              click: function ($event) {
                return _vm.selectAppointmentType("FollowUp")
              },
            },
          },
          [
            _c("img", {
              staticClass: "step1__img",
              attrs: {
                src: "https://midwest-beltone-com-iframes-prod.azurewebsites.net/images/online-scheduling-current-patient.jpg",
                alt: "Current Patient",
              },
            }),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "step1__text" }, [
      _c("p", { staticClass: "step1__text-header" }, [_vm._v("New Patient")]),
      _vm._v(" "),
      _c("p", { staticClass: "step1__text-subheader" }, [
        _vm._v("FREE CONSULTATION | 90 MIN"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "step1__text" }, [
      _c("p", { staticClass: "step1__text-header" }, [
        _vm._v("Current Patient"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "step1__text-subheader" }, [
        _vm._v("FOLLOW-UP | 30 MIN"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }